import { useEffect, useRef } from 'react';

import { ReportsDefaultContext } from 'pages/reports/context/ReportsDefaultContext';
import { GMetrixLoader } from 'components/GMetrixLoader/GMetrixLoader';
import { NotificationContextProvider } from 'app/notifications';
import { StudentGroupWithDetails } from 'apis/StudentGroupApi';
import type { ReportPermissions } from 'pages/reports/types';
import { Option, ReportFilter } from 'apis/ReportApi';
import { DefaultLayout } from 'components/layout';
import { Reports } from 'pages/reports/Reports';
import { PermissionsApi } from 'apis';
import { useSuperState } from 'hooks';
import { useIntl } from 'react-intl';
import { useApp } from 'app';

export const ReportsWrapper = () => {

    const { userId } = useApp();
    const { formatMessage } = useIntl();
    const [state, setState] = useSuperState({
        filters: [] as ReportFilter[] | undefined,
        loading: true,
        permissions: null as ReportPermissions
    });

    const { filters, loading, permissions } = state;

    const classroomCacheRef = useRef(new Map<string, StudentGroupWithDetails[]>());
    const filterOptionsCacheRef = useRef(new Map<string, Option[]>());

    const fetchPermissions = async () => {

        try {

            const permissions = await PermissionsApi.Get('Report');
            setState({ loading: false, permissions });

        } catch (e) {

            console.error(e);
            setState({ loading: false });

        }

    };

    useEffect(() => {

        fetchPermissions();

    }, []);

    return (
        <DefaultLayout pageTitle={formatMessage({ id: 'reports.c01b78b6', defaultMessage: 'Reports' })}>
            <NotificationContextProvider>
                <ReportsDefaultContext.Provider
                    value={{
                        classroomCache: classroomCacheRef.current,
                        currentUserId: userId,
                        filterOptionsCache: filterOptionsCacheRef.current,
                        filters,
                        permissions,
                        setFilters: (filters: ReportFilter[] | undefined) => setState({ filters })
                    }}
                >
                    {loading ? (
                        <div className="d-flex justify-content-center align-items-center" style={{ height: 'calc(100vh - 70px)' }}>
                            <GMetrixLoader />
                        </div>
                    ) : (
                        <Reports />
                    )}
                </ReportsDefaultContext.Provider>
            </NotificationContextProvider>
        </DefaultLayout>
    );

};